import { render, staticRenderFns } from "./VFooter.vue?vue&type=template&id=f58f1f90&scoped=true&"
var script = {}
import style0 from "./VFooter.vue?vue&type=style&index=0&id=f58f1f90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58f1f90",
  null
  
)

export default component.exports